export const m0l3Solution = `%lang starknet
// Functions and other definitions can be scoped in namespaces, making the code more readable.

// Defining a namespace
namespace my_namespace {
    func returns_something() -> (result : felt) {
        return (result=42);
    }
}

@external
func test_hello{syscall_ptr : felt*}() {
    // do not modify code on this line or above

    // TODO: Change the following line to make the test pass
    let (result) = my_namespace.returns_something();

    // do not modify code on this line or below

    assert result = 42;
    return ();
}`;
